/* TEN BUT — Swipe Gallery (Story 3.2) */
(function () {
  if (window.__tbSwipeInit) return;
  window.__tbSwipeInit = true;

  var THRESHOLD = 40;

  // ── PDP Mobile Swipe ──────────────────────────────────────────────
  function initPdpSwipe() {
    var gallery = document.querySelector('[data-tbp-mobile-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-tbp-track]');
    if (!track) return;
    var slides = Array.from(track.querySelectorAll('.tbp__mobile-slide'));
    if (slides.length <= 1) return;
    var dotsEl = gallery.querySelector('[data-tbp-dots]');
    var dots = dotsEl ? Array.from(dotsEl.querySelectorAll('.tbp__mobile-dot')) : [];
    // Story 16.2: a faixa de miniaturas é IRMÃ da galeria (ADR-004 — o touch-action pan-y
    // da galeria zeraria a rolagem horizontal da faixa), por isso a busca sobe um nível.
    var thumbsEl = (gallery.parentNode || document).querySelector('[data-tbp-thumbs]');
    var thumbs = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.tbp__mobile-thumb')) : [];
    var arrows = Array.from(gallery.querySelectorAll('[data-tbp-arrow]'));
    var total = slides.length;
    var idx = 0;
    var startX = 0, startY = 0, deltaX = 0;
    var tracking = false, isHoriz = false, swipeDone = false;

    // Story 14.3 (FR-15): cachear a largura para eliminar forced reflow no touchmove.
    // Antes, gallery.offsetWidth era lido a cada frame do arraste (~60×/s) e também no
    // goTo. Agora medimos só no init, no touchstart (1×/gesto) e no resize/rotação.
    var galleryWidth = 0;
    function measure() { galleryWidth = gallery.offsetWidth; }
    measure();
    window.addEventListener('resize', measure, { passive: true });

    // Recalcula o total pelos slides visíveis: o swap de cor do PDP (variant_gallery)
    // pode ocultar slides excedentes quando a cor tem menos fotos que product.images.
    function visibleCount() {
      var visible = slides.filter(function (s) { return s.style.display !== 'none'; }).length;
      return visible || slides.length;
    }

    // Story 16.2: ponto único de sincronia dos controles novos. Só é chamado de dentro do
    // goTo (ADR-004, condições 1-3): miniaturas e setas nunca escrevem no transform, a
    // classe .is-current nunca é aplicada no touchmove/touchend, e a leitura de layout do
    // reflow forçado acontece 1× por troca de foto — nunca no loop do arraste.
    var syncedOnce = false;
    function syncControls(i, visibleTotal, restartAnim) {
      thumbs.forEach(function (t, n) {
        var active = n === i;
        t.classList.toggle('is-active', active);
        // scrollIntoView só depois da 1ª sincronia: no init a miniatura 0 já está visível e
        // um scroll programático no carregamento poderia mexer na página.
        if (active && syncedOnce && typeof t.scrollIntoView === 'function') {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      });
      arrows.forEach(function (a) {
        var dir = parseInt(a.getAttribute('data-tbp-arrow'), 10) || 0;
        a.disabled = dir < 0 ? i <= 0 : i >= visibleTotal - 1;
      });
      slides.forEach(function (s, n) {
        if (n === i) return;
        s.classList.remove('is-current');
        s.classList.remove('tbp-enter');
      });
      var cur = slides[i];
      if (cur) {
        // .is-current = estado (sempre, e só aqui dentro do goTo — ADR-004 condição 2).
        cur.classList.add('is-current');
        // .tbp-enter = gatilho da animação, separado do estado: no carregamento da página o
        // slide 0 vira corrente sem animar (AC-15 — o zoom marca gesto/seta/miniatura).
        if (restartAnim) {
          // Reinicia a animação: remove → força reflow → re-adiciona.
          // Mesmo padrão de media.__tbCardReset.
          cur.classList.remove('tbp-enter');
          void cur.offsetWidth;
          cur.classList.add('tbp-enter');
        }
      }
      syncedOnce = true;
    }

    function goTo(n, noAnim) {
      total = visibleCount();
      idx = Math.max(0, Math.min(total - 1, n));
      if (!galleryWidth) measure(); // guarda: galeria pode ter sido medida oculta (width 0)
      track.style.transform = 'translateX(-' + (idx * galleryWidth) + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('tbp__mobile-dot--active', i === idx);
      });
      syncControls(idx, total, !noAnim);
      // A janela de pré-carga anda com o dedo: ao mudar de foto, as duas seguintes passam
      // a ser carregadas. `preloadRest` é hoisted e protege-se sozinho antes do `load`.
      preloadRest();
    }
    window.__tbpMobileGoTo = goTo;

    // ── Story 16.3: pré-carga dos slides fora da tela (AC-2, AC-3) ────
    // O track é translateX-ado dentro de um overflow:hidden, então os slides 4+ nunca
    // "entram no viewport" para o lazy-load — o download só começava no primeiro frame do
    // swipe, que é a travada relatada. Aqui eles são promovidos a eager DEPOIS do load.
    // Promove-se o <img> REAL (nunca `new Image()`): o elemento tem srcset+sizes e o
    // browser escolhe o degrau por DPR/viewport — um preload manual pediria outra URL e
    // baixaria um segundo arquivo (AC-3).
    var PRELOAD_FROM = 3; // 0..2 já saem eager do Liquid (AC-1)
    // JANELA, não "tudo" (correcção de 2026-07-23). Promover TODOS os slides restantes de
    // uma vez punha a galeria inteira na fila logo a seguir ao load: medido no `serra`,
    // ~300 KB de slides 800w que ninguém tinha pedido, a competir com o resto da página —
    // e o dono a sentir a PDP presa antes de o deixar rolar. Duas fotos à frente chegam
    // para o próximo swipe (só se avança um slide de cada vez), que é o que a AC-2 pede.
    var PRELOAD_AHEAD = 2;
    // `all` = troca de cor feita pelo cliente: aí pede-se a galeria toda, porque já não há
    // LCP em disputa e um slide por chegar aparece em branco quando ele arrasta.
    function preloadRest(all) {
      // Guarda dura do AC-2: nada compete com a pintura inicial. applyColorImages roda
      // também no carregamento (ten-but-product-main.liquid) e chama esta rotina — sem
      // esta linha, a cor inicial promoveria tudo antes do LCP.
      if (document.readyState !== 'complete') return;
      var limit = all
        ? slides.length
        : Math.min(slides.length, Math.max(PRELOAD_FROM, idx + 1 + PRELOAD_AHEAD));
      for (var i = PRELOAD_FROM; i < limit; i++) {
        // Slide oculto = excedente da cor ativa (applyColorImages usa display:none e mantém
        // o src da cor anterior). Promovê-lo baixaria bytes de foto que ninguém vai ver;
        // quando a cor voltar a ter essa foto, applyColorImages chama esta rotina de novo.
        if (slides[i].style.display === 'none') continue;
        var img = slides[i].querySelector('img');
        if (img && img.loading !== 'eager') img.loading = 'eager';
      }
    }
    // Contrato global para o swap de cor reusar, no mesmo padrão de __tbpMobileGoTo.
    window.__tbpPreloadRest = preloadRest;

    function schedulePreload() {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(preloadRest);
      else setTimeout(preloadRest, 0);
    }
    if (document.readyState === 'complete') schedulePreload();
    else window.addEventListener('load', schedulePreload, { once: true });

    gallery.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      deltaX = 0;
      tracking = false;
      isHoriz = false;
      swipeDone = false;
      measure(); // 1 leitura por gesto — fora do loop de touchmove
      track.style.transition = 'none';
    }, { passive: true });

    gallery.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      deltaX = dx;
      if (!tracking && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        isHoriz = Math.abs(dx) > Math.abs(dy);
        tracking = true;
      }
      if (isHoriz) {
        e.preventDefault();
        track.style.transform = 'translateX(' + (-(idx * galleryWidth) + dx) + 'px)';
      }
    }, { passive: false });

    gallery.addEventListener('touchend', function () {
      track.style.transition = '';
      if (!isHoriz) return;
      if (Math.abs(deltaX) >= THRESHOLD) {
        swipeDone = true;
        goTo(deltaX < 0 ? idx + 1 : idx - 1);
      } else {
        // Snap-back: a foto NÃO trocou — reposiciona sem reiniciar a animação de entrada
        // (Story 16.2, AC-13/AC-15: o zoom marca a chegada de uma foto nova).
        goTo(idx, true);
      }
    }, { passive: true });

    // Tap abre lightbox; swipe nao abre
    gallery.addEventListener('click', function (e) {
      if (swipeDone) { swipeDone = false; return; }
      var btn = e.target.closest('.tbp__m-btn');
      if (!btn) return;
      var i = parseInt(btn.dataset.index, 10);
      if (typeof window.__tbpOpenLightbox === 'function') {
        window.__tbpOpenLightbox(i);
      }
    });

    // ── Story 16.2: controles novos — tudo entra pelo goTo (ADR-004, condição 1) ──
    if (thumbsEl) {
      // Delegação: applyColorImages troca src/display das miniaturas, nunca os elementos.
      thumbsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.tbp__mobile-thumb');
        if (!btn) return;
        var i = parseInt(btn.getAttribute('data-thumb-index'), 10);
        if (isNaN(i)) return;
        goTo(i); // AC-4: navega, não abre o lightbox
      });
    }

    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        var dir = parseInt(a.getAttribute('data-tbp-arrow'), 10) || 0;
        goTo(idx + dir); // AC-10: o clamp do goTo garante ausência de loop
      });
    });

    // Estado inicial: sem animação de entrada (a 1ª foto já está na tela no carregamento).
    syncControls(0, visibleCount(), false);
  }

  // ── Card Swipe (Drop Grid) ────────────────────────────────────────
  // ══════════════════════════════════════════════════════════════════════════════
  // Story 19.5 (AC-B1..B3) — galeria do card SÓ NASCE SOB INTERAÇÃO
  //
  // O documento de /collections/all trazia ~10 <img> de mídia por card: 5 slides do
  // slideshow nativo (invisíveis no mobile, onde ele é display:none) e 5 do track custom
  // (que baixavam sem ninguém ter pedido). Agora o Liquid emite UMA foto — a da cor
  // âncora — e as restantes viajam como URLs em `data-tb-lazy-slides`.
  //
  // Esta rotina hidrata o card no PRIMEIRO `touchstart`, `pointerenter` ou `focusin`, e
  // só então chama `initCardSwipe()`. Nada de `load`, `requestIdleCallback` ou
  // IntersectionObserver: a decisão da epic é sob INTERAÇÃO, não sob tempo ocioso — senão
  // a pré-carga de tudo volta pela porta dos fundos.
  //
  // Idempotência: o atributo é removido ANTES de construir, e a construção também é
  // guardada por `__tbLazyDone`. Uma interação cria uma galeria; as seguintes não
  // duplicam DOM, listener nem request.
  // ══════════════════════════════════════════════════════════════════════════════
  function initCardLazyGallery() {
    document.querySelectorAll('[data-tb-lazy-slides]').forEach(function (media) {
      if (media.__tbLazyBound) return;
      media.__tbLazyBound = true;

      // O gatilho fica no CARD inteiro, não só no track: no desktop o track é
      // display:none e quem recebe o hover é a galeria nativa.
      var host = media.closest('.card-gallery') || media;

      function hydrate(e) {
        if (media.__tbLazyDone) return;
        media.__tbLazyDone = true;
        // O `touchstart` que dispara a hidratação é o MESMO gesto que a cliente quer usar
        // para arrastar — e os listeners de swipe ainda não existiam quando ele passou.
        // Guardamos o ponto de partida para `initCardSwipe` adoptar o gesto em curso;
        // sem isto, o primeiro arrasto de cada card não movia nada.
        if (e && e.type === 'touchstart' && e.touches && e.touches[0]) {
          media.__tbLazyStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
        host.removeEventListener('touchstart', hydrate, { capture: true });
        host.removeEventListener('pointerenter', hydrate);
        host.removeEventListener('focusin', hydrate);

        var raw = media.getAttribute('data-tb-lazy-slides');
        media.removeAttribute('data-tb-lazy-slides');
        var rest;
        try { rest = JSON.parse(raw || '[]'); } catch (_) { rest = []; }

        // AC-B3: se a cliente já escolheu uma cor, a hidratação usa as fotos DESSA cor
        // (o `data-imgs` do swatch selecionado), não as da âncora. Sem isto, tocar num
        // card depois de trocar a cor traria de volta as fotos da cor anterior.
        var card = host.closest('.tb-product-card, product-card, .product-card') || host;
        var picked = card.querySelector('.tb-swatch-btn.is-selected');
        if (picked) {
          var rawImgs = picked.getAttribute('data-imgs');
          var list = rawImgs ? rawImgs.split('|').filter(Boolean) : [];
          if (list.length > 1) {
            rest = list.slice(1).map(function (u) { return { u: u, a: '' }; });
          }
        }

        buildHoverImage(media);
        if (rest.length) {
          buildTrackSlides(media, rest);
          buildSlideshowSlides(host, rest);
        }
        initCardSwipe();

        // O `show_second_image_on_hover` do Horizon está ligado ao MESMO `pointerenter`
        // que acabou de hidratar o card — quando ele correu, ainda só havia um slide, e
        // a pré-visualização saiu no vazio. Um `pointerenter` sintético, depois dos
        // slides existirem, dá-lhe a segunda oportunidade sem esperar que a cliente tire
        // e volte a pôr o rato. Re-entrar em `hydrate` é inofensivo: `__tbLazyDone` já
        // está marcado.
        if (e && e.type === 'pointerenter' && typeof PointerEvent === 'function') {
          try {
            host.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
          } catch (_) { /* browsers sem construtor de PointerEvent: segue sem preview */ }
        }
      }

      host.addEventListener('touchstart', hydrate, { passive: true, capture: true });
      host.addEventListener('pointerenter', hydrate);
      host.addEventListener('focusin', hydrate);
    });
  }

  // Card da Home (ten-but-drop-grid): a 2ª foto existe só para o hover de desktop e
  // estava no documento de toda a gente, mobile incluído, onde nunca é mostrada. Agora
  // nasce aqui, no mesmo gesto que hidrata o track. Clona a principal para herdar classe,
  // `sizes`, `width`/`height` e `loading`.
  function buildHoverImage(media) {
    var url = media.getAttribute('data-tb-lazy-hover');
    if (!url) return;
    media.removeAttribute('data-tb-lazy-hover');
    if (media.querySelector('.tb-product-card__img--hover')) return;
    var main = media.querySelector('.tb-product-card__img');
    if (!main) return;
    var img = main.cloneNode(false);
    img.className = 'tb-product-card__img--hover';
    img.setAttribute('aria-hidden', 'true');
    img.removeAttribute('srcset');
    img.src = url;
    img.srcset = tbSrcsetFrom(url, [360, 540, 720, 900, 1080]);
    img.alt = media.getAttribute('data-tb-lazy-hover-alt') || '';
    media.removeAttribute('data-tb-lazy-hover-alt');
    main.insertAdjacentElement('afterend', img);
  }

  // Track custom (mobile): clona a <img> que o Liquid emitiu e troca a fonte. Clonar, em
  // vez de montar de raiz, preserva classe, `sizes`, `width`/`height` e `loading` — e é o
  // que garante que a foto nova nasce com reserva de espaço (AC-A5).
  function buildTrackSlides(media, rest) {
    var track = media.querySelector('.tb-product-card__swipe-track');
    if (!track) return;
    var first = track.querySelector('.tb-product-card__swipe-slide');
    if (!first) return;
    var frag = document.createDocumentFragment();
    rest.forEach(function (item) {
      var img = first.cloneNode(false);
      img.removeAttribute('srcset');
      img.src = item.u;
      img.srcset = tbSrcsetFrom(item.u, [360, 540, 720, 900]);
      if (item.a) img.alt = item.a;
      frag.appendChild(img);
    });
    track.appendChild(frag);

    // Bolinhas: o Liquid já emitiu `tb_swipe_count` delas (são <span>, não pedem rede).
    // Se por algum motivo faltarem, completamos aqui para o `goTo` ter par.
    var dotsEl = media.querySelector('[data-tb-card-dots]');
    if (dotsEl) {
      var want = track.querySelectorAll('.tb-product-card__swipe-slide').length;
      var have = dotsEl.querySelectorAll('.tb-product-card__dot').length;
      for (var i = have; i < want; i++) {
        var dot = document.createElement('span');
        dot.className = 'tb-product-card__dot';
        dotsEl.appendChild(dot);
      }
    }
  }

  // Slideshow nativo do Horizon (desktop): clona o <slideshow-slide> 0 e reescreve a
  // imagem. O `Component` do tema mantém `refs` em sincronia por MutationObserver
  // (assets/component.js), portanto os slides acrescentados entram em `refs.slides`
  // sozinhos — não há API pública para registá-los à mão.
  function buildSlideshowSlides(host, rest) {
    var comp = host.querySelector('slideshow-component');
    if (!comp) return;
    var slides = comp.querySelectorAll('slideshow-slide');
    if (slides.length !== 1) return; // já hidratado, ou markup diferente do esperado
    var first = slides[0];
    var frag = document.createDocumentFragment();
    rest.forEach(function (item, n) {
      var idx = n + 1;
      var slide = first.cloneNode(true);
      slide.setAttribute('aria-hidden', 'true');
      slide.setAttribute('slide-id', 'tb-lazy-' + idx);
      var st = slide.getAttribute('style') || '';
      slide.setAttribute('style', st.replace(/--slide-\d+/, '--slide-' + idx));
      var img = slide.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-max-resolution');
        img.src = item.u;
        img.srcset = tbSrcsetFrom(item.u, [240, 352, 540, 832, 1200]);
        img.loading = 'lazy';
        if (item.a) img.alt = item.a;
      }
      frag.appendChild(slide);
    });
    first.parentNode.appendChild(frag);
  }

  // Mesmo contrato do `withWidth`/`buildSrcset` da PDP: `width=` é substituído quando já
  // existe e acrescentado quando não — `.replace` sozinho é no-op numa URL sem `width=` e
  // devolveria o ficheiro em resolução máxima.
  function tbSrcsetFrom(url, widths) {
    return widths.map(function (w) {
      var u = /[?&]width=\d+/.test(url)
        ? url.replace(/width=\d+/, 'width=' + w)
        : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      return u + ' ' + w + 'w';
    }).join(', ');
  }

  function initCardSwipe() {
    document.querySelectorAll('[data-tb-card-swipe]').forEach(function (media) {
      if (media.__tbCardSwipeInit) return; // idempotência por card — permite re-init pós-render sem duplicar listeners
      var track = media.querySelector('.tb-product-card__swipe-track');
      if (!track) return;
      var slides = Array.from(track.querySelectorAll('.tb-product-card__swipe-slide'));
      if (slides.length <= 1) return;
      media.__tbCardSwipeInit = true;
      var dotsEl = media.querySelector('[data-tb-card-dots]');
      var dots = dotsEl ? Array.from(dotsEl.querySelectorAll('.tb-product-card__dot')) : [];
      var link = media.closest('.tb-product-card__media-link');
      var total = slides.length;
      var idx = 0;
      var startX = 0, startY = 0, deltaX = 0;
      var tracking = false, isHoriz = false, swipeDone = false;

      // Story 14.3 (FR-15): largura cacheada por card — evita ler media.offsetWidth
      // a cada frame do touchmove. Medimos no init, no touchstart e no resize.
      var mediaWidth = 0;
      function measure() { mediaWidth = media.offsetWidth; }
      measure();
      window.addEventListener('resize', measure, { passive: true });

      function goTo(n) {
        idx = Math.max(0, Math.min(total - 1, n));
        if (!mediaWidth) measure(); // guarda: card pode ter sido medido fora do viewport
        track.style.transform = 'translateX(-' + (idx * mediaWidth) + 'px)';
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === idx);
        });
      }

      // Expõe reset para IntersectionObserver — sem transição (card está fora do viewport)
      media.__tbCardReset = function () {
        if (idx === 0) return;
        var prev = track.style.transition;
        track.style.transition = 'none';
        goTo(0);
        // Força reflow para garantir que o transform foi aplicado antes de restaurar a transição
        void track.offsetWidth;
        track.style.transition = prev;
      };

      // Story 11.4: ajusta o nº de slides/dots "ativos" do track à cor selecionada.
      // A cor pode ter menos fotos que os slides renderizados de product.images (catálogo);
      // ocultamos slides/dots excedentes, reativamos os necessários, atualizamos `total`
      // (clamp do swipe — evita over-swipe em área vazia) e voltamos ao 1º slide.
      // Aditivo/guardado: só é chamado pelo swatch (applyColor), via media.__tbCardSync.
      media.__tbCardSync = function (count) {
        var n = Math.max(1, Math.min(slides.length, count || slides.length));
        slides.forEach(function (s, i) { s.style.display = i < n ? '' : 'none'; });
        dots.forEach(function (d, i) { d.style.display = i < n ? '' : 'none'; });
        total = n;
        media.__tbCardReset();
      };

      media.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        deltaX = 0;
        tracking = false;
        isHoriz = false;
        swipeDone = false;
        measure(); // 1 leitura por gesto — fora do loop de touchmove
        track.style.transition = 'none';
      }, { passive: true });

      media.addEventListener('touchmove', function (e) {
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        deltaX = dx;
        if (!tracking && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          isHoriz = Math.abs(dx) > Math.abs(dy);
          tracking = true;
        }
        if (isHoriz) {
          e.preventDefault();
          track.style.transform = 'translateX(' + (-(idx * mediaWidth) + dx) + 'px)';
        }
      }, { passive: false });

      media.addEventListener('touchend', function () {
        track.style.transition = '';
        if (!isHoriz) return;
        if (Math.abs(deltaX) >= THRESHOLD) {
          swipeDone = true;
          goTo(deltaX < 0 ? idx + 1 : idx - 1);
        } else {
          goTo(idx);
        }
      }, { passive: true });

      // Tap no card navega para produto; swipe nao navega
      if (link) {
        link.addEventListener('click', function (e) {
          if (swipeDone) {
            e.preventDefault();
            swipeDone = false;
          }
        });
      }

      // Story 19.5 (AC-B2): adopta o gesto que provocou a hidratação. Reproduz exactamente
      // o que o handler de `touchstart` teria feito se já estivesse ligado — o `touchmove`
      // seguinte já encontra `startX`/`startY` e a largura medida.
      if (media.__tbLazyStart) {
        startX = media.__tbLazyStart.x;
        startY = media.__tbLazyStart.y;
        deltaX = 0;
        tracking = false;
        isHoriz = false;
        swipeDone = false;
        measure();
        track.style.transition = 'none';
        media.__tbLazyStart = null;
      }
    });

    // Listeners GLOBAIS de reset — registrados UMA ÚNICA VEZ. initCardSwipe() pode ser
    // re-chamado pelo observer (pós-filtro/recomendações); sem este guard, cada re-init
    // duplicaria os handlers de document/window.
    if (!window.__tbCardGlobalInit) {
      window.__tbCardGlobalInit = true;

      // Reset todos os outros cards quando o dedo toca/click em qualquer outro lugar
      // (em outro card OU fora de cards) — UX: cada card volta pra primeira foto
      var resetOthers = function (exceptEl) {
        document.querySelectorAll('[data-tb-card-swipe]').forEach(function (media) {
          if (media !== exceptEl && media.__tbCardReset) {
            media.__tbCardReset();
          }
        });
      };

      // touchstart cobre swipe em outro card; também fora de qualquer card
      document.addEventListener('touchstart', function (e) {
        var card = e.target.closest && e.target.closest('[data-tb-card-swipe]');
        resetOthers(card);
      }, { passive: true, capture: true });

      // mousedown para desktop (caso swipe esteja ativo lá)
      document.addEventListener('mousedown', function (e) {
        var card = e.target.closest && e.target.closest('[data-tb-card-swipe]');
        resetOthers(card);
      }, { passive: true, capture: true });

      // Backup: scroll vertical da página com debounce — pega caso de momentum scroll
      var scrollTimer = null;
      window.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          // Reset todos os cards que estão fora do viewport
          document.querySelectorAll('[data-tb-card-swipe]').forEach(function (media) {
            if (!media.__tbCardReset) return;
            var rect = media.getBoundingClientRect();
            var inViewport = rect.bottom > 0 && rect.top < window.innerHeight;
            if (!inViewport) media.__tbCardReset();
          });
        }, 200);
      }, { passive: true });
    }
  }

  // ── Lightbox Swipe ───────────────────────────────────────────────
  function initLightboxSwipe() {
    var lightbox = document.getElementById('tbp-lightbox');
    if (!lightbox) return;

    // startX = null é o sentinela: toque iniciou num botão, ignorar move/end
    var startX = null, startY = 0, deltaX = 0;
    var tracking = false, isHoriz = false;

    lightbox.addEventListener('touchstart', function (e) {
      if (!lightbox.classList.contains('tbp__lightbox--open')) return;
      // Sempre resetar para que isHoriz de um swipe anterior não vaze para o próximo toque
      startX = null;
      isHoriz = false;
      tracking = false;
      deltaX = 0;
      if (e.target.closest('.tbp__lb-close, .tbp__lb-prev, .tbp__lb-next')) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    lightbox.addEventListener('touchmove', function (e) {
      if (!lightbox.classList.contains('tbp__lightbox--open')) return;
      if (startX === null) return; // toque em botão — não chamar preventDefault
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      deltaX = dx;
      if (!tracking && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        isHoriz = Math.abs(dx) > Math.abs(dy);
        tracking = true;
      }
      if (isHoriz) e.preventDefault();
    }, { passive: false });

    lightbox.addEventListener('touchend', function () {
      if (!lightbox.classList.contains('tbp__lightbox--open')) return;
      if (startX === null) return; // toque em botão, ignorar
      if (!isHoriz || Math.abs(deltaX) < THRESHOLD) return;
      if (typeof window.__tbpNavigate === 'function') {
        window.__tbpNavigate(deltaX < 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  // ── Card Color Swatches ──────────────────────────────────────────
  // Story 8.2: opera tanto no card CUSTOM da homepage (.tb-product-card) quanto no
  // card NATIVO Horizon da coleção/catálogo (product-card / .product-card). A 8.1 injeta
  // o mesmo contrato data-* (.tb-swatch-btn) nos dois; aqui re-miramos os seletores de
  // imagem/links para a estrutura presente em cada card (REUSE > ADAPT).
  function initCardSwatches() {
    document.querySelectorAll('.tb-product-card, product-card, .product-card').forEach(function (card) {
      var swatches = card.querySelectorAll('.tb-swatch-btn');
      if (!swatches.length) return;
      if (card.__tbSwatchInit) return; // idempotência por card (defensivo)
      card.__tbSwatchInit = true;

      function applyColor(btn) {
        var ci = btn.getAttribute('data-img');
        var hi = btn.getAttribute('data-hover-img');
        var url = btn.getAttribute('data-url');
        var priceStr = btn.getAttribute('data-price');
        var rawImgs = btn.getAttribute('data-imgs') || ci;
        var imgs = rawImgs ? rawImgs.split('|') : [ci];

        // ── Estado-selecionado (Story 11.2) — home e catálogo ──────────
        // Marca a bolinha clicada (anel via CSS .is-selected) e limpa as irmãs.
        // a11y: aria-pressed reflete a seleção no grupo de swatches do card.
        swatches.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        // ── Story 19.4 — TODOS os links do card vão para a cor escolhida ────────────
        // Antes, os href eram atualizados um a um por seletor: `.product-card__link`,
        // `a.contents`/`[ref=cardGalleryLink]` e o link do título. Faltava justamente o
        // que o dedo toca no telemóvel: `.tb-cat-swipe-link`, o link do track de swipe do
        // catálogo (Story 11.3), que em ≤749px é `position:absolute; inset:0` e COBRE a
        // galeria inteira — enquanto o `a.contents` nativo fica `display:none`. Resultado:
        // escolher uma cor e tocar no card levava à cor ÂNCORA, não à escolhida. No
        // desktop passava despercebido, porque ali esse link é `display:none` e o clique
        // ia pelo overlay, que era atualizado.
        //
        // A correção não lista seletores: reescreve todo `<a>` do card que aponta para
        // `/products/`. É o contrato real ("todos os caminhos deste card levam ao produto
        // mostrado") e não volta a quebrar quando alguém acrescentar mais um link — foi
        // exatamente assim que este defeito nasceu.
        if (url) {
          card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            a.href = url;
          });
        }

        // ── Preço por cor (fix 2026-06-28) ─────────────────────────────
        // Cores podem ter preços diferentes (ex. vermelho 380 × verde 360). data-price
        // traz o preço da variante representante da cor (1ª disponível). Atualiza a home
        // (.tb-product-card__price) e o catálogo (<product-price> nativo). Sem data-price
        // (preço único), é no-op.
        // CRÍTICO: trocar APENAS o nó de texto do valor (1º text node com dígito), sem
        // tocar em nenhum elemento. setar textContent/innerHTML no contêiner apagaria os
        // <span> internos estilizados (.price/.price-item) e a fonte perderia tamanho/peso
        // (regressão reportada). Assim o preço fica EXATAMENTE com o estilo do render original.
        if (priceStr) {
          var applyPrice = function (el) {
            if (!el) return;
            var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
            var n;
            while ((n = walker.nextNode())) {
              if (/\d/.test(n.nodeValue)) { n.nodeValue = priceStr; return; }
            }
          };
          applyPrice(card.querySelector('.tb-product-card__price'));
          applyPrice(card.querySelector("product-price [ref='priceContainer'], product-price .price"));
        }

        // ── Estrutura CUSTOM (homepage drop-grid) ──────────────────────
        var customImg = card.querySelector('.tb-product-card__img');
        if (customImg) {
          // As <img> do card custom têm srcset (render do Drop Grid). Setar só .src é
          // ignorado pelo browser enquanto o srcset persistir — limpar antes (igual ao
          // ramo nativo abaixo) é o que faz a troca de cor aparecer.
          if (ci) { customImg.srcset = ''; customImg.src = ci; }
          var hoverImg = card.querySelector('.tb-product-card__img--hover');
          if (hoverImg && hi && hi !== ci) { hoverImg.srcset = ''; hoverImg.src = hi; }

          // (os href da home já foram reescritos pelo bloco único acima — Story 19.4)
          var swipe = card.querySelector('[data-tb-card-swipe]');
          if (swipe) {
            var swipeSlides = swipe.querySelectorAll('.tb-product-card__swipe-slide');
            swipeSlides.forEach(function (slide, i) {
              if (imgs[i]) { slide.srcset = ''; slide.src = imgs[i]; }
            });
            if (swipe.__tbCardReset) swipe.__tbCardReset();
          }
        }

        // ── Estrutura CUSTOM do CATÁLOGO (Story 11.4) — track de swipe por cor ──
        // O card nativo do catálogo NÃO tem .tb-product-card__img, então o ramo acima é
        // pulado. Aqui atualizamos o track custom do catálogo (.tb-cat-swipe) de forma
        // ADITIVA e GUARDADA: o seletor .tb-cat-swipe mira SÓ o catálogo (a home já foi
        // tratada acima via .tb-product-card__img), evitando rodar duas vezes.
        var catSwipe = card.querySelector('.tb-cat-swipe[data-tb-card-swipe]');
        if (catSwipe) {
          var catSlides = catSwipe.querySelectorAll('.tb-product-card__swipe-slide');
          catSlides.forEach(function (slide, i) {
            if (imgs[i]) { slide.srcset = ''; slide.src = imgs[i]; }
          });
          // Coerência slides/dots × nº de fotos da cor (AC2): alinha a contagem ativa do
          // track ao data-imgs da cor (oculta excedentes) e volta ao 1º slide (AC1/AC3).
          if (catSwipe.__tbCardSync) catSwipe.__tbCardSync(imgs.length);
          else if (catSwipe.__tbCardReset) catSwipe.__tbCardReset();
        }

        // ── Estrutura NATIVA Horizon (.card-gallery) ───────────────────
        var gallery = card.querySelector('.card-gallery');
        if (gallery) {
          // FR-1.3: troca de imagem. As <img> nativas usam srcset; limpamos srcset
          // para forçar o src novo (CDN direta da cor, Tier 1).
          // Story 11.4 (fecha MNT-001): restrito a img.product-media__image — o catch-all
          // `, img` capturava também os .tb-product-card__swipe-slide do track custom
          // (que vivem DENTRO de .card-gallery) e os sobrescrevia por índice bruto. A
          // classe product-media__image (product-media.liquid:48) mira só as <img> nativas.
          var galleryImgs = gallery.querySelectorAll('img.product-media__image');
          galleryImgs.forEach(function (gimg, i) {
            var nextSrc = imgs[i] || ci;
            if (!nextSrc) return;
            gimg.srcset = '';
            gimg.removeAttribute('data-max-resolution');
            gimg.src = nextSrc;
          });

          // FR-1.4: os href do card já foram apontados para a variante pelo bloco único
          // no topo de applyColor (Story 19.4) — incluindo o `.tb-cat-swipe-link`, que
          // esta lista de seletores não alcançava.
        }
      }

      // ── Seleção inicial (Story 11.2.1) — home e catálogo ───────────
      // Marca, no load, o swatch cuja foto corresponde à imagem que o card já exibe,
      // pra cor ativa aparecer sem precisar clicar. Compara pelo PATH do arquivo
      // (ignora ?v= / ?width=, que variam). Sem match → marca o primeiro como default.
      (function markInitialSelection() {
        // ── Story 19.3: a cor do card é decidida no SERVIDOR ──────────────────────
        // `product-card.liquid` resolve a variante contextual a partir de
        // product.featured_media — a mídia que a Shopify troca conforme o filtro/busca —
        // e marca o swatch dela com data-tb-server-selected. A galeria já sai renderizada
        // nessa cor, com o srcset certo. O casamento por URL abaixo NUNCA acerta quando as
        // fotos do swatch vêm do metafield variant_gallery (ficheiros distintos das mídias
        // do produto: `01_b43f0066…` no swatch × `01_4cc6003b…` na galeria), e por isso
        // caía no `swatches[0]` e marcava a PRIMEIRA cor — foto verde com bolinha laranja
        // no `?filter.v.option.rozmiar=40`. Aqui a marcação do servidor vence, e não se
        // reaplica imagem nenhuma (as URLs do metafield não têm `&width=` — trocá-las no
        // load custaria bytes de LCP sem mudar o que se vê).
        var serverChosen = null;
        swatches.forEach(function (b) {
          if (!serverChosen && b.getAttribute('data-tb-server-selected') === 'true') serverChosen = b;
        });
        if (serverChosen) {
          swatches.forEach(function (b) {
            var on = b === serverChosen;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          return;
        }

        function pathOf(u) {
          if (!u) return '';
          try { return new URL(u, window.location.href).pathname; }
          catch (e) { return u.split('?')[0]; }
        }
        var mainEl =
          card.querySelector('.tb-product-card__img') ||
          card.querySelector('.card-gallery img.product-media__image') ||
          card.querySelector('.card-gallery img');
        var mainMedia = mainEl && mainEl.closest(".product-media[data-media-id]");
        var mainMediaId = mainMedia ? mainMedia.getAttribute("data-media-id") : "";
        var mainPath = mainEl ? pathOf(mainEl.currentSrc || mainEl.src) : '';

        var chosen = null;
        if (mainMediaId) {
          swatches.forEach(function (b) {
            if (chosen) return;
            if (b.getAttribute("data-media-id") === mainMediaId) { chosen = b; }
          });
        }
        if (!chosen && mainPath) {
          swatches.forEach(function (b) {
            if (chosen) return;
            if (pathOf(b.getAttribute('data-img')) === mainPath) { chosen = b; return; }
            var list = (b.getAttribute('data-imgs') || '').split('|');
            for (var i = 0; i < list.length; i++) {
              if (pathOf(list[i]) === mainPath) { chosen = b; break; }
            }
          });
        }
        if (!chosen) chosen = swatches[0];
        if (chosen) {
          swatches.forEach(function (b) {
            var on = b === chosen;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          /* Gate 19.3 / MED-006: no load a marcação para AQUI. `applyColor` troca
             `src` limpando o `srcset`, e as URLs do metafield `variant_gallery` não
             têm `&width=` — é o mecanismo que a EPIC-14 apontou como causa-raiz do
             LCP mobile. A foto que o servidor já pintou É a do swatch casado; não há
             nada a trocar. A troca de imagem continua no clique. */
        }
      })();

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          // Não navegar nem disparar a view-transition do <product-card> (AC4).
          e.preventDefault();
          e.stopPropagation();
          applyColor(btn);
        });
      });

      // ── Cor pedida de fora do clique (defeito 2026-09-16) ────────────────────────────
      // `ten-but-related.js` precisa que o card dos relacionados mostre a cor que TEM o
      // número que a cliente escolheu na PDP — o Articer entrava na lista do 36 exibindo
      // Orange, que só tem 37 e 38. A decisão de QUAL cor é de lá; a troca continua sendo
      // esta função, a única no tema que acerta foto, todos os href, preço e swatch de uma
      // vez nas três estruturas de card.
      //
      // Os dois sentidos existem porque a ordem de chegada não é garantida: este init corre
      // com 80 ms de debounce depois do card aparecer, e o related.js corre no microtask do
      // MutationObserver — antes, portanto. Quem chegar primeiro deixa o pedido; quem chegar
      // por último o cumpre.
      card.__tbApplyColor = applyColor;
      var tbWanted = card.getAttribute('data-tb-want-color');
      if (tbWanted) {
        for (var w = 0; w < swatches.length; w++) {
          if (swatches[w].getAttribute('aria-label') === tbWanted) {
            if (!swatches[w].classList.contains('is-selected')) applyColor(swatches[w]);
            break;
          }
        }
      }
    });
  }

  // ── Re-init pós-render (Section Rendering API + morph assíncrono) ─────
  // O grid do catálogo é REconstruído ao filtrar/ordenar (facets.js → renderSection)
  // e os "Produtos relacionados" são INJETADOS depois do load (product-recommendations.js
  // → morphSection). Em ambos os casos surgem cards NOVOS sem os listeners de swipe/cor.
  // Este observer detecta a chegada desses cards e re-roda os inits (idempotentes via
  // media.__tbCardSwipeInit / card.__tbSwatchInit), religando swipe e troca de cor.
  function initReinitObserver() {
    if (window.__tbReinitObserver) return;
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    window.__tbReinitObserver = true;

    var SELECTOR = '[data-tb-card-swipe], .tb-swatch-btn';

    function carriesCards(node) {
      if (!node || node.nodeType !== 1) return false; // só ELEMENT_NODE
      if (node.matches && node.matches(SELECTOR)) return true;
      return !!(node.querySelector && node.querySelector(SELECTOR));
    }

    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        // Story 19.5 (AC-B2): cards vindos do filtro/ordenação/relacionados também nascem
        // com uma foto só — precisam dos gatilhos de hidratação antes do swipe.
        initCardLazyGallery();
        initCardSwipe();
        initCardSwatches();
      }, 80);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (carriesCards(added[j])) { schedule(); return; }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initPdpSwipe();
    initCardLazyGallery(); // Story 19.5 (AC-B2): só arma os gatilhos, não constrói nada
    initCardSwipe();
    initLightboxSwipe();
    initCardSwatches();
    initReinitObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
